import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import bulb from "./light-bulb.png";
import "./Pricing.css";

const MASTER_FEATURES = [
  "Review Requests / Month",
  "Request Channels",
  "Targeted Campaigns",
  "Supported Locations",
  "Email & Sms Automation",
  "Custom Link Integrations",
  "Direct Review Links",
  "Quick Reaction Buttons",
  "Customer Feedback Surveys",
  "Ai Response Suggestions",
  "Auto-Respond To Reviews",
  "Ai-Powered Insights",
  "Review Site Monitoring",
  "Coupon & Offer Generation",
  "Referral Program Support",
  "Team Performance Leaderboards",
  "Team & Role Management",
  "Brand Customization",
  "Social Media Tools",
  "Dedicated Account Manager",
];

function Pricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [pricingData, setPricingData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPackages = async () => {
    const frequency = isMonthly ? "monthly" : "yearly";
    setLoading(true);
    try {
      const res = await axios.get(
        `https://zola.technology/api/public/packages/list/?frequency=${frequency}`
      );
      setPricingData(res.data || []);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setPricingData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, [isMonthly]);

  const renderCard = (pkg, index) => {
    const hasDiscount =
      parseFloat(pkg.total_price) > parseFloat(pkg.total_discounted_price);

    return (
      <div
        key={pkg.id || index}
        className={`pricing-card ${pkg.is_recommended ? "recommended" : ""}`}
      >
        {pkg.is_recommended && (
          <div className="recommended-header">
            <h4>Recommended</h4>
          </div>
        )}

        <div className="pricing-card_header">
          <h3>{pkg.name}</h3>
          <h2>
            ${parseFloat(pkg.total_discounted_price).toFixed(0)}
            {hasDiscount && (
              <span>${parseFloat(pkg.total_price).toFixed(0)}</span>
            )}
          </h2>
          <p>
            {isMonthly
              ? "Per month billed monthly"
              : "Per year billed annually"}
          </p>
          <hr />
        </div>

        <div className="pricing-card_body">
          {MASTER_FEATURES.map((featureName, i) => {
            const featureObj = pkg.features.find(
              (f) =>
                f.feature?.name?.trim().toLowerCase() ===
                featureName.toLowerCase()
            );

            return (
              <div key={i}>
                <p
                  className={
                    featureObj?.included ? "" : "striked-text text-gray-400"
                  }
                >
                  {featureObj?.custom_label || featureName}
                </p>
                <hr />
              </div>
            );
          })}
        </div>

        <div className="pricing-card_footer">
          <Link>Start free 14-day trial</Link>
        </div>
      </div>
    );
  };

  const renderSkeletonCard = (_, index) => (
    <div key={index} className="pricing-card skeleton-card">
      <div className="pricing-card_header">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-text"></div>
        <hr />
      </div>
      <div className="pricing-card_body">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i}>
            <div className="skeleton skeleton-text"></div>
            <hr />
          </div>
        ))}
        <div className="skeleton skeleton-link"></div>
      </div>
      <div className="pricing-card_footer">
        <div className="skeleton skeleton-button"></div>
      </div>
    </div>
  );

  return (
    <section className="pricing-section">
      <h1>Invest in your company&apos;s success</h1>
      <p>
        Businesses with over 400 reviews more than double the revenue of an
        average business.
      </p>

      <div className="pricing-cards">
        <div className="toggle-pricing">
          <button
            className={isMonthly ? "active" : ""}
            onClick={() => setIsMonthly(true)}
          >
            Pay Monthly
          </button>
          <button
            className={!isMonthly ? "active" : ""}
            onClick={() => setIsMonthly(false)}
          >
            Pay Annually
          </button>
        </div>

        <div className={isMonthly ? "monthly-pricing" : "yearly-pricing"}>
          {loading
            ? Array.from({ length: 3 }).map(renderSkeletonCard)
            : pricingData
                .slice()
                .sort(
                  (a, b) =>
                    parseFloat(a.total_discounted_price) -
                    parseFloat(b.total_discounted_price)
                )
                .map(renderCard)}
        </div>

        <p
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            justifyContent: "center",
            fontSize: "18px",
          }}
        >
          <img style={{ width: "18px", height: "18px" }} src={bulb} alt="" />
          Not seeing a plan that fits your needs?{" "}
          <Link>Talk to our sales.</Link>
        </p>
      </div>
    </section>
  );
}

export default Pricing;
